/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Code_FieldInputs */

const en_admin_permissions_code_field = /** @type {(inputs: Admin_Permissions_Code_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const zh_admin_permissions_code_field = /** @type {(inputs: Admin_Permissions_Code_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`权限代码`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Admin_Permissions_Code_FieldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_code_field = /** @type {((inputs?: Admin_Permissions_Code_FieldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Code_FieldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_code_field(inputs)
	return zh_admin_permissions_code_field(inputs)
});
export { admin_permissions_code_field as "admin.permissions.code_field" }